import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }

        // Remove all non-digit characters
        const digits = value.replace(/\D/g, '');

        // Format the phone number
        const formatted = digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

        return formatted;
    }
}
